import { useLocation, Link, Routes, Route } from "react-router-dom";
import { Tabs, Tab, BigBoldText } from "./setting.style";

//Templates
import ProfileSettings from "./Profile/profile";
import RoleAssignment from "../Users/UserManagement/RoleAssignment/RoleAssignment";
import UpdatePassword from "./UpdatePassword";
import Subscriptions from "./Subscriptions";

const Settings = () => {
  const { pathname } = useLocation();
  const linkStyle = {
    textDecoration: "none",
    color: "initial",
  };
  return (
    // <AdminLayout>
    <>
      <BigBoldText>Settings</BigBoldText>
      <Tabs className="mt-4 overflow-x-auto">
        <Link style={linkStyle} to="/user/settings">
          <Tab
            isActive={pathname === "/user/settings"}
            className="h5 text-md flex h-12 items-center justify-center font-medium"
          >
            Profile
          </Tab>
        </Link>

        <Link style={linkStyle} to="/user/settings/role">
          <Tab
            isActive={pathname === "/user/settings/role"}
            className="h5 text-md flex h-12 w-fit items-center justify-center font-medium"
          >
            {" "}
            Role Assignment
          </Tab>
        </Link>
        <Link style={linkStyle} to="/user/settings/password">
          <Tab
            isActive={pathname === "/user/settings/password"}
            className="h5 text-md flex h-12 items-center justify-center font-medium"
          >
            {" "}
            Password
          </Tab>
        </Link>
        <Link style={linkStyle} to="/user/settings/subscriptions">
          <Tab
            isActive={pathname === "/user/settings/subscriptions"}
            className="h5 text-md flex h-12 items-center justify-center font-medium"
          >
            {" "}
            Subscriptions
          </Tab>
        </Link>
      </Tabs>

      <div className="mt-5">
        <Routes>
          <Route path="/role" element={<RoleAssignment />} />
          <Route path="/password" element={<UpdatePassword />} />
          <Route path="/" element={<ProfileSettings />} />
          <Route path="/subscriptions" element={<Subscriptions />} />
        </Routes>
      </div>
    </>
    // </AdminLayout>
  );
};

export default Settings;
